import type { ReactNode } from 'react';

export const symbol_identity_platform: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M388-488.1q-38-38.1-38-92t38.1-91.9q38.1-38 92-38t91.9 38.1q38 38.1 38 92T571.9-488q-38.1 38-92 38T388-488.1Zm141.5-42.28q20.5-20.38 20.5-49.5t-20.38-49.62q-20.38-20.5-49.5-20.5t-49.62 20.38q-20.5 20.38-20.5 49.5t20.38 49.62q20.38 20.5 49.5 20.5t49.62-20.38ZM149-262q-13.74-8.41-21.37-22.18Q120-297.94 120-314v-332q0-16.06 7.63-29.82Q135.26-689.59 149-698l300-183q14-9 31-9t31 9l300 183q13.74 8.41 21.37 22.18Q840-662.06 840-646v332q0 16.06-7.63 29.82Q824.74-270.41 811-262L511-79q-14 9-31 9t-31-9L149-262Zm331-28q-46 0-89 14.5T313-232l167 101 167-101q-35-29-78-43.5T480-290Zm-224 23q48-38 105-60.5T480-350q62 0 119 22.5T704-267l76-45v-334.23L480-830 180-646.23V-312l76 45Zm224-214Z"
		/>
	</svg>
);
